import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import prestigeParkData from '../../data/projects/prestigepark.js';

function PrestigePark() {
  return <ProjectPage projectData={prestigeParkData} />;
}

export default PrestigePark;
